// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListVehicleMakes_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListVehicleMakes';
  $t: string = 'SagaSchema.ListObjects.ListVehicleMakes';

  public static GetMembers(): string[] {
    return ['VehicleMakeId', 'VehicleMake', 'Description', 'Deleted', 'Priority'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListVehicleMakes_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public VehicleMakeId: number = 0;
  public VehicleMake: string;
  public Description: string;
  public Deleted: boolean = false;
  public Priority: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.VehicleMakeId;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
